<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import HeroBanner from "../components/HeroBanner.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./EsgStrategy.translations.json";
	import heroImgMd from "../assets/images/brano-areal-view-colored.png?webp&w=768&imagetools";
	import heroImg from "../assets/images/brano-areal-view-colored.png?webp&w=1920&imagetools";
	import footerImg from "../assets/images/footerHp.png?webp&w=1920&imagetools";
	import StaticPicture from "../components/Picture/StaticPicture.svelte";
	import { flyInOnScroll } from "../utils/flyInOnScroll.js";
	import ImageBanner from "../components/ImageBanner.svelte";
	import { getTenant } from "../contexts/tenantContextKey.js";
	import { getEsgStrategyAreas } from "../components/esgStrategyAreas.js";
	import EsgStrategyCards from "../components/EsgStrategyCards.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";

	const translate = getTranslate(translations);
	const { locale } = getTenant();

	const areas = getEsgStrategyAreas(locale);

	/* eslint-disable svelte/no-at-html-tags */
</script>

<Layout
	footerImage={footerImg}
	footerHeadline={translate("whereNext")}
	footerSubHeadline={translate("aboutCompany")}
	footerButtonText={translate("buttonText")}
>
	<HeroBanner
		title={translate("headline")}
		class="h-[52.5625rem] overflow-visible lg:h-screen"
		overlay="white-70"
		textColor="black"
		backgroundImage={heroImg}
		backgroundImageMobile={heroImgMd}
		hideShowMore
	>
		<div class="grid w-full grid-cols-1 gap-[0.44rem] lg:grid-cols-3 lg:gap-[1.29rem]">
			<div
				class="row-span-2 flex w-full flex-col justify-between bg-white/50 px-[1.24rem] py-[0.77rem] backdrop-blur-md transition-colors duration-500 hover:bg-white/15 lg:px-[3.625rem]"
			>
				<span class="lg:text-2md text-[1.125rem] leading-[1.44] lg:leading-[1.52]">{translate("goal1")}</span>
				<span class="text-[1.75rem] font-bold leading-[1.21] lg:text-4xl lg:leading-[1.31]">87 % – B</span>
			</div>
			<div
				class="flex w-full flex-col justify-between bg-white/50 p-[1.24rem] py-[0.77rem] backdrop-blur-md transition-colors duration-500 hover:bg-white/15 lg:px-[3.625rem]"
			>
				<span class="lg:text-2md text-[1.125rem] leading-[1.44] lg:leading-[1.52]">{translate("goal2")}</span>
				<span class="text-[1.75rem] font-bold leading-[1.21] lg:text-[2.375rem] lg:leading-[1.31]">90 %</span>
			</div>
			<div
				class="flex w-full flex-col justify-between bg-white/50 p-[1.24rem] py-[0.77rem] backdrop-blur-md transition-colors duration-500 hover:bg-white/15 lg:px-[3.625rem]"
			>
				<span class="lg:text-2md text-[1.125rem] leading-[1.44] lg:leading-[1.52]">{translate("goal4")}</span>
				<span class="text-[1.75rem] font-bold leading-[1.21] lg:text-[2.375rem] lg:leading-[1.31]">100 %</span>
			</div>
			<div
				class="flex w-full flex-col justify-between bg-white/50 p-[1.24rem] py-[0.77rem] backdrop-blur-md transition-colors duration-500 hover:bg-white/15 lg:px-[3.625rem]"
			>
				<span class="lg:text-2md text-[1.125rem] leading-[1.44] lg:leading-[1.52]">{translate("goal3")}</span>
				<span class="text-[1.75rem] font-bold leading-[1.21] lg:text-[2.375rem] lg:leading-[1.31]">100 %</span>
			</div>

			<div
				class="flex w-full flex-col justify-between bg-white/50 p-[1.24rem] py-[0.77rem] backdrop-blur-md transition-colors duration-500 hover:bg-white/15 lg:px-[3.625rem]"
			>
				<span class="lg:text-2md text-[1.125rem] leading-[1.44] lg:leading-[1.52]">{translate("goal5")}</span>
				<span class="text-[1.75rem] font-bold leading-[1.21] lg:text-[2.375rem] lg:leading-[1.31]">94 %</span>
			</div>
		</div>
	</HeroBanner>

	<section>
		<div class="flex flex-col">
			<div class="container flex flex-col gap-8 px-5 py-28 lg:px-12 lg:pb-48 lg:pt-80">
				<h2 class="m-0 text-[2.75rem] font-semibold lg:text-4xl">{translate("sustainableFuture")}</h2>
				<p class="lg:text-2lg text-[2rem]">{translate("sustainableFuturePerex")}</p>
			</div>

			<EsgStrategyCards />
		</div>
	</section>

	{#each areas as area (area.id)}
		<div id={area.id}>
			<ImageBanner contentClass="!pt-28 !p-5 lg:!p-16" title={area.name} image={area.banner}>
				<div class="absolute inset-0 -z-10 bg-black/60"></div>
				<div class="grid grid-cols-1 gap-5 text-white lg:grid-cols-3 lg:grid-rows-[auto,auto] lg:gap-y-20">
					<span use:flyInOnScroll class="lg:text-2lg text-[2rem] lg:col-span-2">{nbspify(area.content)}</span>
					<span use:flyInOnScroll class="self-end text-[1.125rem] lg:text-[1.1875rem] lg:font-bold">
						{nbspify(area.perex)}
					</span>

					{#each area.points.slice(0, 3) as point, index}
						<div
							use:flyInOnScroll={{ y: 100 }}
							class="group flex min-h-[12.5rem] flex-col justify-between bg-[#2B2B2B]/50 px-10 py-5 backdrop-blur-sm lg:min-h-[17.1875rem] lg:px-16 lg:py-7"
						>
							<StaticPicture
								image={area.banner}
								imgClass="!h-full !w-full object-cover"
								class="absolute inset-0 -z-10 opacity-0 brightness-50 transition-opacity duration-500 group-hover:opacity-100"
								width={537}
								height={275}
								alt={point}
							/>
							<span class="lg:text-2md text-[1.125rem]">{translate("commitment")}&nbsp;{index + 1}.</span>
							<span class="lg:text-2lg text-[1.75rem] font-bold">{@html point}</span>
						</div>
					{/each}
				</div>
			</ImageBanner>
		</div>
	{/each}
</Layout>
